// Conversations (29 Oct 2026, docs/specs/NAVIGATION_2026_10.md): who's interested and what's next with them. Connect's
// working pages: every reply on every channel, the next steps only a person can take, meetings and the deals board.
// Connect's accounts and rules live in Settings, its figures in Results.
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { SteppedModule } from "./types";
import { screen } from "./screen";

const pages = () => import("../screens/pipeline/ConnectPages");
const NextStepsPage = screen(pages, "NextStepsPage");
const MeetingsPage = screen(pages, "MeetingsPage");
const MeetingBriefs = screen(pages, "MeetingBriefs");
const RelationshipHistory = screen(pages, "RelationshipHistory");
const DealsBoard = screen(pages, "DealsBoard");
const ConversationsPage = screen(() => import("../screens/pipeline/Conversations"), "ConversationsPage");
const MeetingCardPage = screen(() => import("../screens/pipeline/MeetingCard"), "MeetingCardPage");

export const conversations: SteppedModule = {
  key: "conversations",
  label: "Conversations",
  layout: "steps",
  tabs: [
    // 6.16 everyone waiting for an answer, on every channel: Replies, WhatsApp (window closed) and Missed calls as tabs.
    { key: "inbox", label: "Inbox", pages: [{ slug: "", label: "Inbox", step: "6.16", render: () => <ConversationsPage /> }] },
    { key: "next-steps", label: "Next steps", pages: [{ slug: "", label: "Next steps", step: "4.10", render: () => <NextStepsPage /> }] },
    {
      key: "meetings",
      label: "Meetings",
      pages: [
        { slug: "", label: "Meetings", step: "7.W", render: () => <MeetingsPage /> },
        { slug: "briefs", label: "Briefs", step: "8.1", render: () => <MeetingBriefs /> },
        { slug: "history", label: "Relationship history", step: "8.1", render: () => <RelationshipHistory /> },
      ],
    },
    { key: "deals", label: "Deals", pages: [{ slug: "", label: "Deals", step: "9.W", render: () => <DealsBoard /> }] },
  ],
  // A meeting's card sits under Meetings.
  extraPages: [{ path: "/conversations/meetings/:id", label: "Meeting", step: "7.W", render: () => <MeetingCardPage /> }],
  taskHomes: {
    // 6.10, 6.11 replies the inbox agent leaves for you
    decide_reply: ["/conversations/inbox"],
    review_reply: ["/conversations/inbox"],
    approve_whatsapp_reply: ["/conversations/inbox"],
    whatsapp_handoff: ["/conversations/inbox"],
    missed_call: ["/conversations/inbox"],
    // 3.18 your own to-dos (Home's until 30 Oct 2026), beside the other next steps
    owner_todo: ["/conversations/next-steps"],
    // 9.14 a person's step on a path, and the other things only you can do to move a sale on
    path_step: ["/conversations/next-steps"],
    add_right_contact: ["/conversations/next-steps"],
    follow_up: ["/conversations/next-steps"],
    confirm_attendance: ["/conversations/next-steps"],
    add_meeting_notes: ["/conversations/next-steps"],
    approve_document: ["/conversations/next-steps"],
    decide_deal_outcome: ["/conversations/next-steps"],
    decide_after_chasers: ["/conversations/next-steps"],
    choose_route: ["/conversations/next-steps"],
    approve_save_offer: ["/conversations/next-steps"],
    // 8.1, 8.3 a meeting coming up and its brief; 7.1 to 7.12 booking problems, answers and cancellations
    hold_meeting: ["/conversations/meetings"],
    read_brief: ["/conversations/meetings/briefs"],
    find_meeting_time: ["/conversations/meetings"],
    decide_meeting_reply: ["/conversations/meetings"],
    booking_problem: ["/conversations/meetings"],
    meeting_cancelled: ["/conversations/meetings"],
    meeting_followups: ["/conversations/meetings"],
  },
};
